// extracted by mini-css-extract-plugin
module.exports = {"popover-content":"style_popover-content__2dUty"};